import { IDENTITY_ROLE_CLIENTS } from "./generated/identity-role-clients";
export type WorkspaceClient =
  "learners" | "parents" | "instructors" | "proctors" | "organizations" | "institutions" | "admins";
// Older contracts used the bare family name. Exact aliases do not accept arbitrary prefixes.
const aliases: Record<string, WorkspaceClient> = {
  learner: "learners",
  parent: "parents",
  instructor: "instructors",
  proctor: "proctors",
  organization: "organizations",
  institution: "institutions",
};
export function workspaceClients(roles: string[]): WorkspaceClient[] {
  return [
    ...new Set(
      roles
        .map(role => IDENTITY_ROLE_CLIENTS[role] || aliases[role])
        .filter((client): client is WorkspaceClient => !!client),
    ),
  ];
}
